import builder from '../builder';
import OfficeFilePPT1 from '../../streamline-icons/bold/office-file-ppt-1.svg';

export default builder('OfficeFilePPT1Bold', OfficeFilePPT1);
